import { typographyStyles, constants } from "@newsela/angelou";
const { ui } = constants.colors;
const { heading4Obj, fontFamily, fontSize } = typographyStyles;
import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";

const white = ui.white[500];
const e1Gradient = `linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), linear-gradient(102deg, ${fullGradientColors.position0.color} 0%, ${fullGradientColors.position25.color} 25%, ${fullGradientColors.position50.color} 50%, ${fullGradientColors.position100.color} 100%)`;

export const collapseButtonCss = {
  fontWeight: "bold",
  textDecoration: "underline",
};
export const headerCss = {
  borderRadius: "10px 10px 0 0",
  display: "flex",
  justifyContent: "space-between",
  background: e1Gradient,
  padding: "1em",
};
export const headerAndIconCss = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "12px",
};

export const headingTextCss = {
  color: ui.neutral[700],
  margin: "0",
  ...heading4Obj,
  ...fontFamily.noto,
};

export const taglineCss = {
  color: ui.neutral[700],
  marginTop: "10px",
  marginBottom: "8px",
  ...fontSize.textS,
};

export const tabListCss = {
  display: "flex",
  justifyContent: "start",
  gap: "8px",
  marginBottom: "1em",
  padding: "1em 1em 0",
  overflowX: "auto",
  overflowY: "hidden",
  marginRight: "-1em",
};

export const bodyCss = {
  background: ui.white[500],
  borderRadius: "0 0 0.6em 0.6em",
};

export const bodyPaddingCss = {
  padding: "0 1em 1em",
};

export const tabButtonCss = (isSelected = false) => {
  return {
    whiteSpace: "nowrap",
    placeContent: "center",
    ...(isSelected && {
      borderBottom: `4px solid ${ui.core[700]}`,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }),
  };
};

export const algorithmOutputCss = {
  whiteSpace: "pre-wrap",
  padding: "1em",
  margin: "0 1rem 1rem",
  border: `1px solid ${ui.neutral[100]}`,
  borderRadius: "4px",
  background: ui.white[500],
};

export const actionButtonsCss = {
  display: "flex",
  flexFlow: "row wrap",
  justifyContent: "space-between",
  gap: "8px",
  marginTop: "1em",
  marginBottom: "1em",
  color: ui.neutral[500],
  "> div": {
    textAlign: "right",
  },
};

export const disclaimerCss = {
  color: ui.neutral[500],
  marginTop: "1em",
  fontStyle: "italic",
};

export const expanderContentCss = { overflow: "hidden" };

export const rootCss = (isTeacherToolsCollapsed = false) => {
  return {
    border: "1px solid transparent",
    borderRadius: isTeacherToolsCollapsed ? "10px 10px 0 0" : "10px",
    width: "100%",
    maxWidth: "900px",
    marginBottom: "2em",
    zIndex: "0",
    background:
      `linear-gradient(${white}, ${white}) padding-box, ` +
      `linear-gradient(282deg, ${fullGradientColors.position100.color} 0%, ${fullGradientColors.position50.color} 52.24%, ${fullGradientColors.position25.color} 77.37%, ${fullGradientColors.position0.color} 102.51%) border-box`,
    backgroundClip: "padding-box, border-box",
  };
};

export const newTagCss = {
  ...fontFamily.circular,
  ...fontSize.textXS,
  marginLeft: "-4px",
  padding: "4px 8px",
  borderRadius: "0.75rem",
  zIndex: 1,
  color: ui.neutral[25],
  background: ui.core[500],
};
